<template>

	<div class="video-wrapper">

		<video class="main-video" :src="source" controls @click="togglePlay"></video>
		<button @click="closePlayer" class="button-close"></button>
		<div v-if="!isIOS">
			<button class="play-button" v-if="!isAutoplaySupport && !isMobilePlay" @click="togglePlay"></button>
		</div>
		
		<div class="wrap-indicator">
			<div class="progress-indicator" @click="skipTo">
				<div class="progress-indicator__bar" :style="'width:' + videoProgressPercentage + '%'" :class="currentPage"></div>
			</div>
		</div>
	</div>

</template>

<script>
import { EventBus, i18n, router } from '../main.js';
import plyr from 'plyr/dist/plyr.js';
import styles from 'plyr/dist/plyr.css';
require('../helper.js');

export default {
	props: ['poster', 'source'],
	data: () => ({
		isMounted: false,
		player: {},
		videoLength: 0,
		videoProgress: 0,
		currentPage: '',
		isAutoplaySupport: null,
		isMobilePlay: false,
		isIOS: false
	}),
	computed:{
		videoProgressPercentage(){
			return this.videoProgress / this.videoLength * 100
		}
	},
	mounted() {

		let that = this;
		let playerOptions = {
			controls: [],
			autoplay: true,
			clickToPlay: false
		}

		let playerOptionsAutoPlayNone = {
			controls: [],
			autoplay: false,
			clickToPlay: false
		}

	

		
			this.isAutoplaySupport = window.Modernizr.videoautoplay;

			if (this.isAutoplaySupport) {
				this.isMobilePlay = true;
				this.player = plyr.setup('.main-video', playerOptions)
			} else {
				this.isMobilePlay = false;
				this.player = plyr.setup('.main-video', playerOptionsAutoPlayNone)
			}

			this.player[0].on('loadeddata', () => {
				this.videoLength = this.player[0].getDuration()
			})
			this.player[0].on('timeupdate', (p, e) => {
				this.videoProgress = this.player[0].getCurrentTime()
			})
			this.player[0].on('ended', () => {
				this.closePlayer()
				router.push('contact')
			})
			this.hideProgress();
			this.isIOS = iOS();

	},
	methods: {
		togglePlay() {
			this.player[0].togglePlay()

			if (this.isMobilePlay === true) {
				this.isMobilePlay = false;
			} else {
				this.isMobilePlay = true;
			}
		},
		closePlayer() {
			this.isMobilePlay = false;
			EventBus.$emit('closePlayer')
		},
		skipTo(e){
			var rect = e.currentTarget.getBoundingClientRect();
					var x = e.clientX - rect.left; //x position within the element.
					let time = this.videoLength * x / rect.width

					this.player[0].seek(time)
					this.player[0].play()
				}, 
				hideProgress(){
					function hasClass(element, className) {
						return element.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(element.className);
					}
					var progress = document.querySelector('.wrap-indicator');

					setTimeout(function(){
						progress.classList.add('hide');
					}, 1500);

					window.addEventListener("mousemove", function(){
						if(hasClass(progress, 'hide') === true) {
							progress.classList.remove('hide');
							setTimeout(function(){
								progress.classList.add('hide');
								clearInterval();
							}, 1500)
						}
					});
				}
			}
		}
		</script>

		<style lang="scss">

		.page-home.creative {
			.wrap-indicator {
				.progress-indicator {
					.progress-indicator__bar {
						background: #96bbf6;
					}
				}
			}
			.play-button {
				background-image: url(../../assets/img/play-button-blue.png);
			}
		}
		.hide{
			opacity: 0;
			transition: opacity 0.3s;
		}
		.video-wrapper {
			display: flex;
			justify-content: center;
			align-items: center;
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			background: rgba(0, 0, 0, 1);
			height: 100vh;
			z-index: 99;
			.main-video {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}

			.plyr__video-wrapper {
				height: 100vh;
				width: 100vw;
				overflow: hidden;
			}

			.wrap-indicator {
				position: fixed;
				z-index: 999;
				bottom: 16.2%;
				left: 50%;
				transform: translate(-50%, 0);
				padding: 5px 0;
				transition: all .3s;
				cursor: pointer;
				&:hover{
					transition: all .3s;
					.progress-indicator {
						height: 7px;
						transition: all .3s;
						bottom: calc(7.5% + 37.5px);
						.progress-indicator__bar {
							transition: all .3s;
							height: 7px;
							top: 5px;
						}
					}
				}
				.progress-indicator {
					width: 377px;
					height: 2px;
					background: #a2a2a2;
					transition: all .3s;
					.progress-indicator__bar {
						position: absolute;
						top: 5px;
						left: 0;
						height: 2px;
						background: #998551;
						transition: all .3s;
					}
				}
			}
		}
		.page-home.creative {
			.button-close {
				background-image: url(../../assets/img/closeButtonBlue.png);
			}
		}

		.button-close {
			cursor: pointer;
			position: absolute;
			top: 5px;
			right: 5px;
			border: none;
			background: url(../../assets/img/closeButton.png) no-repeat;
			background-size: 20px 20px;
			width: 20px;
			height: 19.8px;
			&:focus {
				outline: none;
			}
		}


		</style>


// WEBPACK FOOTER //
// src/components/player.vue